import { cookiesGlobal } from "../App";
import { HttpUrls } from "../global/http_url";

const createPosterAPI = async (posterData) => {
    const token = cookiesGlobal.get('auth');
    try {
        // Calculate payload size for debugging
        const payloadString = JSON.stringify(posterData);
        const payloadSize = new Blob([payloadString]).size;
        const payloadSizeMB = payloadSize / (1024 * 1024);
        
        if (payloadSizeMB > 2) {
            console.warn(`Payload size is ${payloadSizeMB.toFixed(2)}MB, which may exceed server limits`);
        }

        let response = await fetch(HttpUrls.createPoster, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,
            },
            method: 'POST',
            body: payloadString
        });
        
        // Handle 413 error specifically
        if (response.status === 413) {
            return {
                statusCode: 413,
                response: 'Request payload is too large. Please use smaller images.',
            }
        }

        const responseData = await response.json();
        if (response.status === 200) {
            return {
                statusCode: response.status,
                response: responseData['data'],
            }
        } else {
            return {
                statusCode: response.status,
                response: responseData['message'] || responseData['error'] || 'Failed to create poster',
            }
        }

    } catch (e) {
        // Check if it's a network error that might be related to size
        if (e.message && (e.message.includes('413') || e.message.includes('too large'))) {
            return {
                statusCode: 413,
                response: 'Request payload is too large. Please use smaller images.',
            }
        }
        return {
            statusCode: 505,
            response: 'Internet Connection',
        }
    }
}

const getPostersAPI = async () => {
    try {
        let response = await fetch(HttpUrls.getPosters, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            method: 'GET',
        });
        const responseData = await response.json();
        if (response.status === 200) {
            return {
                statusCode: response.status,
                response: responseData['data'],
            }
        } else {
            return {
                statusCode: response.status,
                response: responseData['message'],
            }
        }

    } catch (e) {
        return {
            statusCode: 505,
            response: 'Internet Connection',
        }
    }
}

const deletePosterAPI = async (posterId) => {
    const token = cookiesGlobal.get('auth');
    try {
        let response = await fetch(`${HttpUrls.deletePoster}/${posterId}`, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,
            },
            method: 'POST',
        });
        const responseData = await response.json();
        return {
            statusCode: response.status,
            response: responseData,
        }
    } catch (e) {
        return {
            statusCode: 505,
            response: 'Internet Connection',
        }
    }
}

export { createPosterAPI, getPostersAPI, deletePosterAPI };

